import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/toPromise';
import { Subject } from 'rxjs/Rx'
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { AppraisalService } from '../services/appraisal.service';
import { LoginService } from '../services/login.service'
import {MatTableDataSource} from '@angular/material';


@Component({
  selector: 'app-self-appraisal-list',
  templateUrl: './self-appraisal-list.component.html',
  styleUrls: ['./self-appraisal-list.component.css']
})
export class SelfAppraisalListComponent implements OnInit {

   appraisalData=[];
   appraisal_msg;
   self_code;
   appraisal_year;
   parti_appraisal_year = null;
   dataTable: any;

   /***********calculate apprisal years */

   

  
  
 
  constructor( private apprais : AppraisalService,public ls : LoginService, private router : Router, private chRef: ChangeDetectorRef) {

   /* var d = new Date();
    var to_year = d.getFullYear()-1;
    var a = to_year +1;
     this.parti_appraisal_year = to_year + '-' + a;
    //this.parti_appraisal_year = '2017-2018';
    this.appraisal_year = this.getAppraisalYears();
    console.log( this.parti_appraisal_year);
    this.getUserList(this.parti_appraisal_year);*/
    /*this.getUserList(this.parti_appraisal_year);
    setTimeout(function(){
      $(function(){
        $('#example').DataTable();
      });
    },3000);*/
    this.getUserList(this.parti_appraisal_year);

   }


  ngOnInit() {
    this.self_code = this.ls.employeeCode;
    this.appraisal_msg = localStorage.getItem('appraisal_msg');
    localStorage.removeItem('appraisal_msg');
    
   
  }

  getUserList(parti_appraisal_year)
  {
    this.appraisalData = new Array<any>();
    console.log(parti_appraisal_year);
    var users = this.apprais.getSelfAppraisalData(parti_appraisal_year).subscribe( res => {

      console.log(res);
      //this.chRef.detectChanges();
      this.appraisalData = res.appraisalData;
      this.appraisal_year = res.appraisal_year;
      this.parti_appraisal_year = res.parti_appraisal_year;
      this.chRef.detectChanges();
      const table: any = $('#example');
      
      this.dataTable = table.DataTable();
     //table.draw();
      
            // Now you can use jQuery DataTables :
           // const table: any = $('table');
          /* setTimeout(function(){
            $(function(){
              
              var table =  $('#example').DataTable();
              table.clear();
            });
          },3000);*/
      console.log(this.appraisalData);
  })
 
  }

  onSubmit(assignAppraisalYear)
  {
    
   //alert('hi');
    // console.log(this.parti_appraisal_year);
     this.dataTable.destroy();
    this.getUserList(this.parti_appraisal_year);

    //this.router.navigate(['/selfAppraisalAssign']);
    
      
   
   
  }

 

}



// WEBPACK FOOTER //
// ./src/app/self-appraisal-list/self-appraisal-list.component.ts